import Rating from '../../rating/rating';
import './profilecard.css';

function ProfileCard(props) {
  const { card } = props;
  return (
    <div className="card profile">
      <Rating text="4.92" subText="24" />
      <div className="img_box" style={{ backgroundColor: card.bgColor }}>
        <img src={card.image} alt="" className="profile_img" />
      </div>
      <h3 dir="auto" className="name">
        {card.name}
      </h3>
      <h5 dir="auto" className="professtion">
        {card.proff}
      </h5>
      <p dir="auto" className="desc">
        {card.edu}
      </p>
      <p dir="auto" className="desc">
        {card.exp}
      </p>
    </div>
  );
}

export default ProfileCard;
